import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Chart } from "react-google-charts";
import greybullet from "../../assets/img/grey-bullet.svg";
import greenbullet from "../../assets/img/green-bullet.svg";
import redbullet from "../../assets/img/red-bullet.svg";
import yellowbullet from "../../assets/img/yellow-bullet.svg";
import bluebullet from "../../assets/img/blue-bullet.svg";
import warningOn from "../../assets/img/Warning_on.svg";
import warningOff from "../../assets/img/Warning_off.svg";
import closeIcon from "../../assets/img/cross-icon.svg";
import { getLocaleStringNumber } from "../utils/utils";
import { docModalStylesNoTranslateY } from "../utils/styles";
import EstadoCrediticio from "./EstadoCrediticio";
import { allMateriales } from "../utils/materiales";
import {
  showGreyBackground,
  hideGreyBackground
} from "../utils/windows";

const materialIconsContext = require.context("../../assets/img", false, /^\.\/material-.*\.(png|svg)$/);

function buildStockConsignado(detail) {
  if (!detail) return null;
  const out = {};
  detail.forEach((s) => {
    const eds = (parseInt(s.SOLICITANTE, 10)).toString();
    const total = s.STOCK_CONSIGNADO * s.VALOR_UNITARIO;
    s.total = total;
    if (!out[eds]) out[eds] = { detalle: [], total: 0 };
    out[eds].detalle.push(s);
    out[eds].total += total;
  });
  return out;
}

function getMaterialCellContent(item) {
  const mat = allMateriales[item.MATERIAL];
  const icon = mat?.imgIcon;
  if (!icon) return mat?.miniTitle || "";
  try {
    const mod = materialIconsContext("./" + icon);
    const imgSrc = mod?.default ?? mod;
    if (!imgSrc) return mat?.miniTitle || "";
    return <img src={imgSrc} alt={mat?.miniTitle || ""} className="stock-consignado-material-img" />;
  } catch {
    return mat?.miniTitle || "";
  }
}

function chartDataFromEstado(ec) {
  const nonNeg = (v) => (v != null && v < 0 ? 0 : v);
  return [
    ["Partida", "Valor"],
    ["Partidas Vencidas", nonNeg(ec.PARTIDAS_VENCIDAS)],
    ["Partidas Abiertas", nonNeg(ec.PARTIDAS_ABIERTAS)],
    ["Partidas en Curso", nonNeg(ec.PARTIDAS_EN_CURSO)],
    ["Stock Consignado", nonNeg(ec.STOCK_CONSIGNADO)],
    ["Credito Disponible", nonNeg(ec.CREDITO_DISPONIBLE)]
  ];
}

const CHART_OPTIONS = {
  legend: "none",
  is3D: false,
  pieHole: 0.68,
  tooltip: { trigger: "none" },
  pieSliceBorderColor: "transparent",
  pieSliceText: "none",
  chartArea: { width: "85%", height: "85%" },
  slices: {
    0: { color: '#ea212e' },
    1: { color: '#ffb906' },
    2: { color: '#0e69af' },
    3: { color: '#7c97ab' },
    4: { color: '#49d78e' },
  }
};

function StockConsignadoTableBody({ stockConsignado }) {
  if (!stockConsignado) return null;
  const keys = Object.keys(stockConsignado);
  const hasMultipleEds = keys.length > 1;
  const totalInvConsig = hasMultipleEds
    ? keys.reduce((sum, k) => sum + (stockConsignado[k].total || 0), 0)
    : 0;

  return (
    <>
      {keys.map((key) => {
        const items = stockConsignado[key].detalle || [];
        const valorTotalLabel = hasMultipleEds ? "Valor Total EDS" : "Valor Total";
        return (
          <React.Fragment key={key}>
            <tr><td className="row-separator" colSpan="100%" /></tr>
            <tr>
              <td className="stock-consignado-subtitle" colSpan="100%">EDS {key}</td>
            </tr>
            <tr><td className="row-separator" colSpan="100%" /></tr>
            {items.map((item, index) => (
              <React.Fragment key={`${key}-${item.MATERIAL}`}>
                <tr className={`data${index === 0 ? " data-first" : ""}${index === items.length - 1 ? " data-last" : ""}`}>
                  <td className="stock-consignado-material">{getMaterialCellContent(item)}</td>
                  <td className="align-right">{item.STOCK_CONSIGNADO != null ? getLocaleStringNumber(item.STOCK_CONSIGNADO) : ""}</td>
                  <td className="align-right">{item.VALOR_UNITARIO != null ? getLocaleStringNumber(item.VALOR_UNITARIO) : ""}</td>
                  <td className="align-right">{item.total != null ? getLocaleStringNumber(item.total) : ""}</td>
                </tr>
                {index < items.length - 1 && (
                  <tr>
                    <td className="row-separator-inner" colSpan="100%" />
                  </tr>
                )}
              </React.Fragment>
            ))}
            <tr><td className="row-separator" colSpan="100%" /></tr>
            <tr>
              <td className="valor-total-title" colSpan="2">{valorTotalLabel}</td>
              <td className="valor-total-value" colSpan="2">${getLocaleStringNumber(stockConsignado[key].total)}</td>
            </tr>
          </React.Fragment>
        );
      })}
      {hasMultipleEds && (
        <>
          <tr><td className="row-separator-big" colSpan="100%" /></tr>
          <tr>
            <td className="valor-total-title valor-total-inv-consig" colSpan="2">Valor Total Inv. Consig.</td>
            <td className="valor-total-value valor-total-inv-consig" colSpan="2">${getLocaleStringNumber(totalInvConsig)}</td>
          </tr>
        </>
      )}
    </>
  );
}

const CreditoCard = (props) => {
  const estadoCrediticio = props.estadoCrediticio;
  const [stockConsignado, setStockConsignado] = useState([]);
  const [displayStockConsignadoModal, setDisplayStockConsignadoModal] = useState(false);

  useEffect(() => {
    const next = buildStockConsignado(estadoCrediticio.STOCK_CONSIGNADO_DETALLE);
    if (next) {
      setStockConsignado(next);
      console.log("GuardandonewStock consignado:::  ", next);
    }
  }, [estadoCrediticio])

  const openStockConsignado = () => {
    if (estadoCrediticio.STOCK_CONSIGNADO === 0) {
      return;
    }
    setDisplayStockConsignadoModal(true);
    showGreyBackground()
  }

  const closeStockConsignadoModal = () => {
    setDisplayStockConsignadoModal(false);
    hideGreyBackground()
  }

  return (
    <div className="estado-crediticio">
      <div className="info1">
        <div className="numbers">
            <div className="credito">
                <div className="titlec"> <img src={greenbullet}></img>Crédito disponible</div>
                <div className="montoc">{`$ ${getLocaleStringNumber(estadoCrediticio.CREDITO_DISPONIBLE)}`}</div>
            </div>
          <div className="partida">
            <div className="title">
               Abonos
            </div>
            <div className="monto">{`$ ${getLocaleStringNumber(estadoCrediticio.ABONOS)}`}</div>
          </div>
          <div className="partida">
            <div className="title">Límite de crédito</div>
            <div className="monto">{`$ ${getLocaleStringNumber(estadoCrediticio.LIMITE_CREDITO)}`}</div>
          </div>
        <hr className="sep3"></hr>
          <div className="partida">
            <div className="title">Total crédito asig.</div>
            <div className="monto"><b>{`$ ${getLocaleStringNumber(estadoCrediticio.TOTAL_CREDITO)}`}</b></div>
          </div>
        </div>
        <div className="chart">
          <Chart
            width={"100px"}
            height={"100px"}
            chartType="PieChart"
            loader={<div>Loading Chart</div>}
            data={chartDataFromEstado(estadoCrediticio)}
            options={CHART_OPTIONS}
            rootProps={{ "data-testid": "3" }}
          />
        </div>
      </div>
      <div className="info2">
        <div className="numbers">
          <div className="partida">
            <div className="title">
              <img src={redbullet}></img> Partidas Vencidas
            </div>
            <div className="monto">{`$ ${getLocaleStringNumber(estadoCrediticio.PARTIDAS_VENCIDAS)}`}</div>
          </div>
          <div className="partida">
            <div className="title"><img src={yellowbullet}></img>Partidas No Venc.</div>
            <div className="monto">{`$ ${getLocaleStringNumber(estadoCrediticio.PARTIDAS_ABIERTAS)}`}</div>
          </div>
          <div className="partida">
            <div className="title"><img src={bluebullet}></img>Pedidos en Curso</div>
            <div className="monto">{`$ ${getLocaleStringNumber(estadoCrediticio.PARTIDAS_EN_CURSO)}`}</div>
          </div>
          <div className="partida">
            <div className={estadoCrediticio.STOCK_CONSIGNADO === 0 ? 'title' : 'title stock-consignado-link'} onClick={openStockConsignado}><img src={greybullet}></img>Inventario Consig.</div>
            <div className="monto">{`$ ${getLocaleStringNumber(estadoCrediticio.STOCK_CONSIGNADO)}`}</div>
          </div>
          <hr className="sep5"></hr>
          <div className="partida">
            <div className="title">Crédito Comprometido</div>
            <div className="monto"><b>{`$ ${getLocaleStringNumber(estadoCrediticio.CREDITO_COMPROMETIDO)}`}</b></div>
          </div>

        </div>
        <div className="warning">
          <img src={estadoCrediticio.CHEQUES_RECHAZADOS === "Si" ? warningOn : warningOff} alt="" />
          <p>{estadoCrediticio.CHEQUES_RECHAZADOS === "Si" ? "Cheques Rechazados" : ""}</p>
        </div>
      </div>
      {
        estadoCrediticio.STOCK_CONSIGNADO !== 0 && (
          <button className="estado-crediticio-mobile-button" onClick={openStockConsignado}>Ver detalle</button>
        )
      }

      <Modal
        isOpen={displayStockConsignadoModal}
        onRequestClose={closeStockConsignadoModal}
        style={docModalStylesNoTranslateY()}
      >
        <button className="modal__close-btn modal__close-btn--stock-consignado" onClick={closeStockConsignadoModal}>
          <img src={closeIcon} alt="close modal" />
        </button>

        <div className="stock-consignado-modal">
          <div className="title center">Detalle Inventario Consignación</div>
          <hr />
          <div className="stock-consignado-modal--container">
            <table>
              <thead>
                <tr>
                  <th>Material</th>
                  <th>Inventario<br />Consig. (lts.)</th>
                  <th>Precio<br />Unitario ($)</th>
                  <th>Valor<br />Total ($)</th>
                </tr>
              </thead>
              <tbody>
                <StockConsignadoTableBody stockConsignado={stockConsignado} />
              </tbody>
            </table>
          </div>
          <div className="actions-container">
            <hr />
            <button className="aceptar-button" onClick={closeStockConsignadoModal}>Aceptar</button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CreditoCard;
